// Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// UI Imports
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import IconArrowBack from '@material-ui/icons/ArrowBack';
import IconClose from '@material-ui/icons/Close';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import FileUpload from '@mui/icons-material/FileUpload';
// App Imports
import { nullToEmptyString, capitalizeFirstLetter, toTitleCase, toTitleCaseAddress } from '../../../setup/helpers';
import { upload, messageShow } from '../../common/api/actions';
import SectionPaper from '../../common/SectionPaper';
import BrandedLoading from '../../common/BrandedLoading';
import ImageComp from '../../common/Image';
import { detail } from '../api/actions/query'
import { update } from '../api/actions/mutation'
import { updateAddress } from '../api/actions/mutation'
import { getImageSource } from '../../user/api/routes';
import { searchByAddress } from '../../vendor/api/actions/query';

// Component
class Update extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isLoadingSubmit: false,
      vendor: {
        name: '',
        email: '',
        mobile: '',
        image: '',
        industryType: ''
      },
      address: {
        _id:'',
        userId: '',
        street1: '',
        street2: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        fullAddress: '',
        lat: '',
        lng: '',
        xCoord: '',
        yCoord: '',
        placeId: "",
      },
      addressSuggestions: [],
      selectedValidatedAddress: null,
      isValidatingAddress: false,
      previewImage:null
    }
  }

  componentDidMount() {
    this.getDetails()
  }

  getDetails = async () => {
    const { match: { params: { vendorId } }, detail } = this.props
    this.isLoadingToggle(true)

    try {
      const { data } = await detail({ userId: vendorId })

      if (data.success) {
        this.setState({ vendor: data.data.user })
        this.setState({ address: data.data.address.length > 0 ? data.data.address[0] : '' });
      } else {
        messageShow(data.message)
      }
    } catch (error) {
      messageShow('Some error occurred. Please try again.')
    } finally {
      this.isLoadingToggle(false)
    }
  }

  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading
    })
  }

  onType = ({ target: { name, value } }) => {
    const { vendor } = this.state

    if (name === 'email') {
      vendor[name] = value
    } else {
      vendor[name] = capitalizeFirstLetter(value)
    }

    this.setState({ vendor });
  }

  onTypeAddress = ({ target: { name, value } }) => {
    const { address } = this.state;
    address[name] = value;
    this.setState({ address });
  };

  handleAddressValidation = async () => {
    const { address: { street1, street2, city, pincode } } = this.state;
    if (street1 && city && pincode) {
      const searchText = `${street1.trim()}, ${street2.trim()}, ${city.trim()}, ${pincode.trim()}`;
      this.setState({ isValidatingAddress: true });
      try {
        const { data } = await this.props.searchByAddress(searchText);
        if (data?.success) {
          this.setState({ addressSuggestions: data.data || [] });
        }
      } catch (error) {
        console.error("Address validation failed:", error);
      } finally {
        this.setState({ isValidatingAddress: false });
      }
    }
  };

  onSelectValidatedAddress = (event) => {
    const selectedId = event.target.value;
    const selected = this.state.addressSuggestions.find(
      (addr) => addr.id === selectedId
    );

    if (!selected) return;

    const desc = selected.description || "";
    const parts = desc.split(",").map((p) => p.trim());
    let street1 = selected.mainText || "";
    let street2 = "";
    let city = "";
    let state = "";
    let country = "";
    let pincode = "";

    const postcodeRegex = /\b([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}|\d{5,6})\b/i;
    const match = desc.match(postcodeRegex);
    if (match) pincode = match[0].toUpperCase();

    country = parts[parts.length - 1] || "";

    const codePart = parts.find((p) => p.includes(pincode)) || "";

    if (codePart) {
      const splitCity = codePart.replace(pincode, "").trim();
      city = toTitleCase(splitCity);
    } else {
      city = toTitleCase(parts[parts.length - 2] || "");
    }

    state = "";

    const updatedAddress = {
      ...this.state.address,
      street1: toTitleCase(street1),
      street2: street2 ? toTitleCase(street2) : "",
      city,
      state,
      country: toTitleCase(country),
      pincode,
      fullAddress: toTitleCaseAddress(desc),
      placeId: selected.placeId,
      lat: "",
      lng: "",
      xCoord: "",
      yCoord: "",
    };


      this.setState({
        selectedValidatedAddress: selectedId,
        address: updatedAddress
      });
  };

  onUpload = async (event) => {
    const { upload, messageShow } = this.props

    messageShow('Uploading file, please wait...')
    const imgFile = event.target.files[0];
    let file = new FormData()
    file.append("type", "user")
    file.append("file",imgFile);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const fileResult = fileReader.result;
      let dataAsImg = new Image();
      dataAsImg.src = fileResult;
      this.setState({ previewImage: dataAsImg.src });
    };
    fileReader.readAsDataURL(imgFile);
    // Upload image
    try {
      const { data } = await upload(file)

      if (data.success) {
        messageShow('File uploaded successfully.')

        const { vendor } = this.state

        setTimeout(() => {
          vendor.image = data.file
          this.setState({
            vendor
          })
        }, 1500)

      } else {
        messageShow('There was some error. Please try again.')
      }
    } catch (error) {
      messageShow('There was some error. Please try again.',error)
    }
  }

  submit = async event => {
    event.preventDefault()

    const { vendor, address } = this.state
    const { update, updateAddress, messageShow, history } = this.props;

    this.isLoadingSubmitToggle(true);

    try {
      const { data: vendorData } = await update({ vendor });
      const { data: addressData } = await updateAddress({ address });

      this.isLoadingSubmitToggle(false)

      if (vendorData.success && addressData.success ) {
        messageShow('Vendor Details updated Successfully');
        history.goBack()
      } else {
        messageShow('Something went wrong !!!');
      }
    } catch (error) {
      messageShow('Something went wrong !!!')
      this.isLoadingSubmitToggle(false)
    }
  }

  isLoadingSubmitToggle = (isLoadingSubmit) => {
    this.setState({ isLoadingSubmit });
  }
  
  back = () => {
    const { history } = this.props

    history.goBack()
    
  }

  render() {
    const { isLoading, vendor, address, isLoadingSubmit, addressSuggestions, selectedValidatedAddress, isValidatingAddress } = this.state
    return (
        <div>
          <Toolbar className={styles.toolbar}>
            <IconButton color="inherit" onClick={this.back}>
              <IconArrowBack />
            </IconButton>

            <Typography variant="h6" color="inherit" >
              Edit Profile
          </Typography>
          </Toolbar>
          <Grid item xs={12} lg={6}>
            <SectionPaper padding>
              {
                isLoading 
                ? (
                <BrandedLoading />
              ) : (
                <form onSubmit={this.submit}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        name="name"
                        value={nullToEmptyString(vendor.name)}
                        onChange={this.onType}
                        label="Name"
                        placeholder="Enter vendor name"
                        margin="dense"
                        autoComplete="off"
                        fullWidth
                        autoFocus
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        name="industryType"
                        value={nullToEmptyString(vendor.industryType)}
                        onChange={this.onType}
                        label="Industry Type"
                        margin="dense"
                        fullWidth
                      >
                        <MenuItem value="Restaurant">Restaurant</MenuItem>
                        <MenuItem value="Business">Business</MenuItem>
                        <MenuItem value="clinic">Clinic</MenuItem>
                        <MenuItem value="beauty service">Beauty Service</MenuItem>
                        <MenuItem value="coaching institute">Coaching Institute</MenuItem>
                        <MenuItem value="IT Consulting">IT Consulting</MenuItem>
                        <MenuItem value="Engineering Services">Engineering Services</MenuItem>
                        <MenuItem value="Healthcare Services">Healthcare Services</MenuItem>
                        <MenuItem value="Medical Practice / Doctors">Medical Practice / Doctors</MenuItem>
                        <MenuItem value="Legal Services">Legal Services</MenuItem>
                        <MenuItem value="Accounting Services">Accounting Services</MenuItem>
                        <MenuItem value="Business Advisory">Business Advisory</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField
                        name="email"
                        value={nullToEmptyString(vendor.email.toLowerCase())}
                        onChange={this.onType}
                        label="Email"
                        placeholder="Enter Email"
                        margin="dense"
                        autoComplete="off"
                        fullWidth
                        autoFocus
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        name="mobile"
                        type="tel"
                        value={nullToEmptyString(vendor.mobile)}
                        onChange={this.onType}
                        label="Mobile"
                        placeholder="Enter Mobile"
                        margin="dense"
                        autoComplete="off"
                        fullWidth
                        autoFocus
                      />
                    </Grid>

                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      name="street1"
                      value={nullToEmptyString(address.street1)}
                      onChange={this.onTypeAddress}
                      label="Street 1"
                      placeholder="Enter Street 1"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="street2"
                      value={nullToEmptyString(address.street2)}
                      onChange={this.onTypeAddress}
                      label="Street 2"
                      placeholder="Enter Street 2"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      name="city"
                      value={nullToEmptyString(address.city)}
                      onChange={this.onTypeAddress}
                      label="City"
                      placeholder="Enter City"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="state"
                      value={nullToEmptyString(address.state)}
                      onChange={this.onTypeAddress}
                      label="State"
                      placeholder="Enter State"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      name="country"
                      value={nullToEmptyString(address.country)}
                      onChange={this.onTypeAddress}
                      label="Country"
                      placeholder="Enter Country"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="pincode"
                      value={nullToEmptyString(address.pincode)}
                      onChange={this.onTypeAddress}
                      label="Pincode"
                      placeholder="Enter Pincode"
                      margin="dense"
                      autoComplete="off"
                      fullWidth
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={this.handleAddressValidation}
                      disabled={isValidatingAddress}
                      style={{ marginTop: 16 }}
                    >
                     Validate Address
                    </Button>
                  </Grid>
                </Grid>
                {isValidatingAddress ? (
                  <CircularProgress size={24} style={{ marginTop: 10 }} />
                ) : (
                  addressSuggestions.length > 0 && (
                    <TextField
                      select
                      label="Select Validated Address"
                      value={selectedValidatedAddress || ''}
                      onChange={this.onSelectValidatedAddress}
                      fullWidth
                      margin="dense"
                      style={{ marginTop: 10}}
                    >
                      {addressSuggestions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.description}
                        </MenuItem>
                      ))}
                    </TextField>
                  )
                )}

                    <Grid item sm={6} style={{ paddingTop: '30px' }}>
                      <div style={{ marginBottom: 20 }}>
                        <input
                          accept="image/png,image/jpeg"
                          style={{ display: 'none' }}
                          id="contained-button-file"
                          type="file"
                          onChange={this.onUpload}
                        />
                        <label htmlFor="contained-button-file">
                          <Button
                            variant="outlined"
                            component="span"
                            type="file"
                            fullWidth
                          >
                            <FileUpload
                            fontSize="16"
                            style={{ marginInlineEnd: 16 }}
                            />
                            Upload Image
                        </Button>
                        </label>
                      </div>
                      {!this.state.previewImage ? (
                        <ImageComp
                          src={getImageSource(`${vendor.image}`)}
                          defaultSrc={getImageSource()}
                          size={150}
                        />
                      ) : (
                        <img
                          height="auto"
                          width="100%"
                          src={this.state.previewImage}
                          alt="preview_user"
                        ></img>
                      )}
                    </Grid>

                    <Grid item xs={12} style={{ textAlign: 'right', marginTop: '20px' }}>
                      <IconButton
                        type="button"
                        aria-label="Close"
                        onClick={this.back}
                      >
                        <IconClose />
                      </IconButton>
                      <IconButton
                        type="v"
                        aria-label="Save"
                        color="primary"
                        disabled={isLoadingSubmit}
                      >
                        <CheckIcon/>
                      </IconButton>
                    </Grid>
                  </form>
              )}
            </SectionPaper>
          </Grid>
        </div>
    )
  }
}

Update.propTypes = {
  detail: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  updateAddress: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  searchByAddress: PropTypes.func.isRequired,
};

export default connect(null, { detail, upload, messageShow, update, updateAddress, searchByAddress })(withStyles(styles)(Update));
